import {api, routes} from "@/plugins/axios";

export function useResources() {
    const getAllResources = (organizationSlug, page, perPage, search, startDate, endDate, type, tags, filter, orderBy, orderByDirection, category) => {
        return api.get(routes.resources.list(organizationSlug, page, perPage, search, startDate, endDate, type, tags, filter, orderBy, orderByDirection, category))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const getResource = (organizationSlug, resourceId) => {
        return api.get(routes.resources.get(organizationSlug, resourceId))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const like = (organizationSlug, resourceId) => {
        return api.post(routes.resources.like(organizationSlug, resourceId))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const unlike = (organizationSlug, resourceId) => {
        return api.delete(routes.resources.unlike(organizationSlug, resourceId))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const deleteResource = (organizationSlug, resourceId) => {
        return api.delete(routes.resources.delete(organizationSlug, resourceId))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const showResource = (organizationSlug, resourceUid) => {
        return api.get(routes.resources.show(organizationSlug, resourceUid)).then((response) => {
            return Promise.resolve(response.data);
        }).catch((err) => {
            return Promise.reject(err);
        });
    }

    const shareResource = (organizationSlug, resourceUid, data) => {
        return api.post(routes.resources.share(organizationSlug, resourceUid), data)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    return {
        getResource,
        deleteResource,
        getAllResources,
        like,
        unlike,
        showResource,
        shareResource,
    }
}
